import { render, staticRenderFns } from "./GoodSearch.vue?vue&type=template&id=501e7ca0&scoped=true"
import script from "./GoodSearch.vue?vue&type=script&lang=js"
export * from "./GoodSearch.vue?vue&type=script&lang=js"
import style0 from "./GoodSearch.vue?vue&type=style&index=0&id=501e7ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e7ca0",
  null
  
)

export default component.exports